import type { Theme } from '@mui/material/styles';

/**
 * Disabled map/to-do when the event has no map — same rules for the left drawer
 * and bottom bar so the gray-out matches.
 */
export function mapTodoDisabledNavSx(theme: Theme) {
    return {
        pointerEvents: 'none' as const,
        opacity: theme.palette.action.disabledOpacity,
        color: theme.palette.text.disabled,
        '& .MuiSvgIcon-root': {
            color: theme.palette.text.disabled,
        },
        '& .MuiBottomNavigationAction-label': {
            color: theme.palette.text.disabled,
            opacity: 1,
        },
        '& .MuiListItemText-primary': {
            color: theme.palette.text.disabled,
        },
    };
}
